// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a25e4e25","453":"ed09b5e1","455":"5659e564","977":"d3df15c2"}[chunkId] + ".chunk.js";
};